import React, { useContext, useState } from 'react';
import {
  initialValues,
  validationSchema,
} from '../config/createProblemFormConfig';
import './ReportProblemForm.css';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import ReportIssueError from '../../../../reportissue/components/ReportIssueError';
import FormikCustomSelect from './FormikCustomSelect';
import { useMutation } from '@tanstack/react-query';
import { UserContext } from '../../../../../../App';
import FIELD_TYPE from './selectOptions/FieldType';
import LocationComponent from './selectOptions/LocationComponent';
import DMA from './selectOptions/DMA';
import { ClipLoader } from 'react-spinners';

export default function ReportProblemForm({
  formInfo,
  setFormInfo,
  increaseFormStep,
}) {
  const { userDetails } = useContext(UserContext);
  const { problemLocation } = formInfo;

  const [submittingForm, setSubmittingForm] = useState(false);

  const token = localStorage.getItem('token');

  const apiUrl = process.env.REACT_APP_BACKEND_API;

  const handleSubmitFormStatus = (value) => {
    setFormInfo((prevValue) => {
      return {
        ...prevValue,
        formSubmitStatus: value,
      };
    });
  };

  const onSubmit = (values, onSubmitProps) => {
    setSubmittingForm(true);
    if (values.image !== '') {
      const formData = new FormData();

      formData.append('folder', 'problems');
      formData.append('documents', values.image);

      const submitData = {
        values,
        formData,
      };

      uploadProblemImageMutate(submitData);
    } else reportProblemMutate(values);
  };

  const { mutate: reportProblemMutate } = useMutation({
    mutationFn: (problemData) =>
      fetch(`${apiUrl}/problems`, {
        method: 'POST',
        body: JSON.stringify({
          ...problemData,
          geom: {
            type: 'Point',
            coordinates: [
              problemLocation.coordinates.x,
              problemLocation.coordinates.y,
            ],
          },
          suggestion:
            problemData.suggestion === '' ? null : problemData.suggestion,
          user: userDetails,
          userDepartment: userDetails.department,
          issue: !formInfo?.issueDetails ? null : formInfo.issueDetails,
          image: !problemData?.image ? null : problemData.image,
          description: !problemData?.description
            ? null
            : problemData.description,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => res.json()),

    onSuccess: (response) => {
      if (
        (response.statusCode < 300 && response.statusCode > 199) ||
        !response.statusCode
      ) {
        handleSubmitFormStatus(true);
        setSubmittingForm(false);
        increaseFormStep();
        return;
      }
      handleSubmitFormStatus(false);
      increaseFormStep();
    },
    onError: (error) => {
      console.log('error', error);
      setSubmittingForm(false);
      handleSubmitFormStatus(false);
      increaseFormStep();
    },
  });

  const { mutate: uploadProblemImageMutate } = useMutation({
    mutationFn: (problemData) =>
      fetch(`${apiUrl}/upload/documents`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: problemData.formData,
      }).then((res) => res.json()),

    onSuccess: (response, problemData) => {
      if (
        (response.statusCode < 300 && response.statusCode > 199) ||
        !response.statusCode
      ) {
        reportProblemMutate({
          ...problemData.values,
          image: response.documents[0].newName,
        });
      } else {
        handleSubmitFormStatus(false);
        increaseFormStep();
      }
    },
    onError: () => {
      console.log('error');
      handleSubmitFormStatus(false);
      increaseFormStep();
    },
  });

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        validateOnChange={false}
      >
        {(formik) => {
          const fieldValidation = (fieldName) => {
            formik.validateField(fieldName);
          };

          const convertSelectValueToNumber = (fieldName, e) => {
            formik.setFieldValue(fieldName, parseInt(e.target.value, 10));
          };

          return (
            <Form>
              <div>
                <div className="report-problem-form-body">
                  <div>
                    <div>
                      <label htmlFor="address" className="form-label">
                        Adresa kvara
                      </label>
                      <Field
                        type="text"
                        id="address"
                        name="address"
                        maxLength="40"
                        className="form-problem-field "
                      />
                      <ErrorMessage
                        name="address"
                        component={ReportIssueError}
                      />
                    </div>

                    <FormikCustomSelect
                      selectLabel={'Vrsta terena'}
                      selectName={'fieldType'}
                      selectList={FIELD_TYPE}
                      validateSelection={() => fieldValidation('fieldType')}
                      convertSelectValueToNumber={convertSelectValueToNumber}
                    />

                    <FormikCustomSelect
                      selectLabel={'Pozicija'}
                      selectName={'locationComponent'}
                      selectList={LocationComponent}
                      validateSelection={() =>
                        fieldValidation('locationComponent')
                      }
                      convertSelectValueToNumber={convertSelectValueToNumber}
                    />
                    <FormikCustomSelect
                      selectLabel={'DMA zona'}
                      selectName={'dma'}
                      selectList={DMA}
                      validateSelection={() => fieldValidation('dma')}
                      convertSelectValueToNumber={convertSelectValueToNumber}
                    />
                  </div>

                  <div>
                    <div className="form-field-container">
                      <label htmlFor="description" className="form-label">
                        Opis kvara
                      </label>
                      <Field
                        as="textarea"
                        id="description"
                        name="description"
                        maxLength="180"
                        className="form-problem-field  form-textarea"
                      />
                      <ErrorMessage
                        name="description"
                        component={ReportIssueError}
                      />
                    </div>

                    <div className="form-field-container">
                      <label htmlFor="suggestion" className="form-label">
                        Prijedlog rješenja
                      </label>
                      <Field
                        as="textarea"
                        id="suggestion"
                        name="suggestion"
                        className="form-problem-field form-textarea"
                      />
                      <ErrorMessage
                        name="suggestion"
                        component={ReportIssueError}
                      />
                    </div>

                    <div className="form-field-container">
                      <label htmlFor="image" id="image" className="form-label">
                        Fotografija kvara
                      </label>
                      <input
                        type="file"
                        id="image"
                        name="image"
                        onChange={(e) => {
                          formik.setFieldValue('image', e.target.files[0]);
                        }}
                      />
                      <ErrorMessage name="image" component={ReportIssueError} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="report-problem-button-container">
                <button
                  type="submit"
                  className="report-problem-button"
                  disabled={submittingForm}
                >
                  {submittingForm ? (
                    <ClipLoader
                      color={'white'}
                      loading={submittingForm}
                      size={20}
                      data-testid="loader"
                    />
                  ) : (
                    'Unesi kvar'
                  )}
                </button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}
